import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

const useLimitTextShortcuts = ({ toggleLimit }: { toggleLimit?: () => void }) => {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || e.shiftKey || isModalOpen) {
                return;
            }

            switch (e.code) {
                case 'KeyL': {
                    if (toggleLimit) {
                        toggleLimit();
                    }

                    break;
                }

                default:
                    break;
            }
        },
        [toggleLimit, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useLimitTextShortcuts;
